import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=b769b1aa&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"
import style0 from "./page2.vue?vue&type=style&index=0&id=b769b1aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b769b1aa",
  null
  
)

export default component.exports